import React, { useEffect, useState } from 'react'
import { InputGroup, Modal, Button, Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import useGetAllCategories from '../ReuseApi/useGetAllCategories';
import axios from 'axios';
import * as Icon from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { useProjectList } from '../ReuseApi/useProjectList ';
import useGetSubDepartments from '../ReuseApi/useGetSubDepartments';
import { taskPriorityOptions } from '../../utils/constant';

const CreateTaskModel = ({ show, close, userData }) => {

  const navigate = useNavigate()
  const loginUserData = useSelector((state) => state.loginData.userData)
  const userDataDept = loginUserData?.department.map((itm) => { return itm.label }).toString()
  const userDept = userData?.department.map((itm) => { return itm.label }).toString()
  const activeTabName = useSelector((state) => state.activeData?.activeNumberKey?.activeTab);

  // state for data
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [taskpriority, setTaskpriority] = useState("")
  const [departmentName, setDepartmentName] = useState([])
  const [subDepartment, setSubDepartment] = useState("")
  const [projectname, setProjectname] = useState("")
  const [categoryname, setCategoryname] = useState("")
  const [assignto, setAssignto] = useState("")
  const [proposedStartDate, setProposedStartDate] = useState("")
  const [proposedEndDate, setProposedEndDate] = useState("")
  const [initialHr, setInitialHr] = useState("")
  const [initialminute, setInitialMinute] = useState("")
  const [errors, setErrors] = useState({});

  const [localDeptOptions, setLocalDeptOptions] = useState({
    data: [],
    selectedListInd: null,
    selectedOptionInd: null
  });
  const [assignToOptions, setAssignToOptions] = useState([])

  // for validation
  const handlerValidate = () => {
    let newErrors = {};

    if (!taskName) newErrors.taskName = "Required Field";
    if (!taskpriority) newErrors.taskpriority = "Required Field";
    if (!taskDescription) newErrors.taskDescription = "Required Field";
    if (!projectname) newErrors.projectname = "Required Field";
    if (!departmentName) newErrors.departmentName = "Required Field";
    if (subDeptOptions.length > 0 && !subDepartment) newErrors.subDepartment = "Required Field";
    // if (!categoryname) newErrors.categoryname = "Required Field";
    if (!assignto) newErrors.assignto = "Required Field";
    if (!proposedStartDate) newErrors.proposedStartDate = "Required Field";
    if (!proposedEndDate) newErrors.proposedEndDate = "Required Field";
    if (!initialHr) newErrors.initialHr = "Required Field";
    if (!initialminute) newErrors.initialminute = "Required Field";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // custom hook 
  const { allCategoriesOptions } = useGetAllCategories(departmentName, subDepartment);
  const { subDeptOptions } = useGetSubDepartments(departmentName?.value);
  const { projectOptions, departmentOptions } = useProjectList(projectname?.value);

  // toast msg 
  const AddTaskSuccess = (res) => {
    if (res?.assignBy_Name !== res?.resourceName && res?.departmentName === userDataDept) {
      toast.success("Assigned Task Successfully", {
        toastId: "assign-success"
      });
    }
    else if (res?.assignBy_Name !== res?.resourceName && res?.departmentName !== userDataDept) {
      toast.success("Assigned Task Successfully", {
        toastId: "assign-success"
      });
    }
  };

  const InitialHrMinute = () => {
    toast.error("00 hours and 00 minutes at the same time are not permitted, please choose an acceptable time.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "initialHrMinute-error"
    });
  }

  // reset data
  const resetForm = () => {
    setTaskName("");
    setTaskDescription("");
    setTaskpriority("");
    setDepartmentName(null);
    setProjectname(null);
    setCategoryname(null);
    setAssignto(null);
    setSubDepartment(null);
    setProposedStartDate("");
    setProposedEndDate("");
    setInitialHr("");
    setInitialMinute("");
    setErrors({});
  };


  useEffect(() => {
    const fetchDeptAndAssignToOptions = async () => {
      const payload = userDataDept !== userDept ?
        {
          departmentName: departmentName ? departmentName.label : "",
          subDepartment: subDepartment ? subDepartment.label : "",
        }
        :
        {
          departments: activeTabName === "Other Department Task" ? ["others"] : "",
          subDepartment: "",
          empId: loginUserData?.empId
          // departments: departmentName?.label ? [departmentName.label] : loginUserData.department.map((itm) => itm.label),
          // subDepartment: subDepartment ? [subDepartment] : loginUserData.subDepartmentName.map((itm) => itm),
          // empId: loginUserData?.empId
        };
      const urlEndpoint = '/emp/getEmployeeByDepartment';

      axios.post(process.env.REACT_APP_BASE_URL + urlEndpoint, payload)
        .then((res) => {
          const deptOptions = [];
          const assignToOptions = [];

          // const filterOption = (res?.data?.data)?.length > 0 && (res?.data?.data)?.map((itm) => {
          //     return ({ value: itm.empId, label: `${itm.firstName} ${itm.lastName}` })
          // })

          if (res?.data?.data?.length) {
            res.data.data.forEach(item => {
              const userObj = {
                label: `${item.firstName} ${item.lastName}`,
                value: item.empId
              }

              deptOptions.push(item.department)
              assignToOptions.push(userObj)
            })
          }

          // if (filterOption?.length > 0) {
          //     setAllAssignToOptions(filterOption)
          // }

          setLocalDeptOptions({
            data: deptOptions,
            selectedListInd: null,
            selectedOptionInd: null
          });
          setAssignToOptions(assignToOptions);
        })
        .catch((err) => {
          console.log("Error", err)
        })
    }

    fetchDeptAndAssignToOptions();

  }, [activeTabName])


  // for submit data
  const handleSubmit = (e) => {
    if (handlerValidate()) {
      if (parseFloat(initialHr) === 0 && parseFloat(initialminute) === 0) {
        InitialHrMinute();
      } else {
        const payload = {
          empId: assignto?.value,
          taskName: taskName,
          taskDescription: taskDescription,
          taskPriority: taskpriority?.value,
          department_id: (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.value : loginUserData?.department[0]?.value,
          departmentName: (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.label : loginUserData?.department[0]?.label,
          taskDepartmentId: departmentName.value,
          taskDepartmentName: departmentName.label,
          projectId: projectname.value,
          projectName: projectname.label,
          AssignTask: "",
          assignBy_id: userData?.empId,
          assignBy_Name: `${userData.firstName} ${userData.lastName}`,
          resource_id: assignto.value,
          resourceName: assignto.label,
          categoryOfName: categoryname?.label || "",
          category_id: categoryname?.value || "",
          // categoryOfName: categoryname.label,
          // category_id: categoryname.value,
          proposedStartDate: new Date(proposedStartDate).toISOString().split('T')[0],
          proposedEndDate: new Date(proposedEndDate).toISOString().split('T')[0],
          initialEstimateHr: initialHr,
          initialEstimateMinutes: initialminute,
          estimateHr: "",
          status: "pending",
          subDepartmentId: subDepartment?.value,
          subDepartmentName: subDepartment?.label,
          logStatus: {
            status: "pending",
            resource_id: assignto.value,
            resourceName: assignto.label
          }
        }
        axios.post(process.env.REACT_APP_BASE_URL + '/task/addTask', payload)
          .then((res) => {
            if ((loginUserData?.department).some((itm) => itm.label === departmentName.label)) {
              AddTaskSuccess();
              resetForm();
              setTimeout(() => {
                navigate(`/${loginUserData?.resourceType}/employee-task`)
              }, 2000)
            } else {
              AddTaskSuccess();
              resetForm();
              setTimeout(() => {
                navigate(`/${loginUserData?.resourceType}/assign-task`)
              }, 1000)

            }
            close()
          })
          .catch((err) => {
            console.log("Error", err)
          })
      }
    }
  }

  return (
    <>
      <ToastContainer />
      <Modal show={show} onHide={close} size="lg" centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title><h5>Assign Task</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body size="lg">

          {/* Row 1 */}
          <Row className='mb-4'>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Assign To
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={assignto}
                  options={assignToOptions}
                  onChange={(option) => {
                    const index = assignToOptions.findIndex(
                      (itm) => itm.value === option.value && itm.label === option.label
                    );
                    setLocalDeptOptions((prev) => ({
                      ...prev,
                      selectedListInd: index,
                      selectedOptionInd: 0,
                    }));
                    setDepartmentName(localDeptOptions.data[index][0]);
                    setAssignto(option);
                  }}
                />
                {errors.assignto && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.assignto}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Department Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={departmentName}
                  options={localDeptOptions.selectedListInd != null ? localDeptOptions.data[localDeptOptions.selectedListInd] : []}
                  isDisabled={localDeptOptions.selectedOptionInd === null}
                  onChange={(option) => {
                    const optionIndex = localDeptOptions.data[localDeptOptions.selectedListInd].findIndex(
                      (itm) => itm.value === option.value && itm.label === option.label
                    );
                    setLocalDeptOptions((prev) => ({
                      ...prev,
                      selectedOptionInd: optionIndex,
                    }));
                    setDepartmentName(option);
                    setSubDepartment(null);
                  }}
                />
                {errors.departmentName && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.departmentName}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  SubDepartment Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={subDepartment}
                  options={subDeptOptions}
                  isDisabled={!departmentName || subDeptOptions.length === 0}
                  onChange={(option) => {
                    setSubDepartment(option);
                    setCategoryname(null);
                  }}
                />
                {errors.subDepartment && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.subDepartment}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Row 2 */}
          <Row className='mb-4'>
            <Col sm={12} md={6}>
              <Form.Group controlId="formBasicId">
                <Form.Label className="mt-3 fw-bold">
                  Task Title
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Task Name"
                    value={taskName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        !value.match(/[#$&%!~=^_{}\[\]*|//\/?<>;`/\\]/) &&
                        value.trim()
                      ) {
                        setTaskName(value);
                      } else if (value.length === 0) {
                        setTaskName(value);
                      }
                    }}
                  />
                </InputGroup>
                {errors.taskName && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskName}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Task Priority
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={taskpriority}
                  options={taskPriorityOptions}
                  onChange={(option) => {
                    setTaskpriority(option);
                  }}
                />
                {errors.taskpriority && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskpriority}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Row 3 */}
          <Row className='mb-4'>
            <Col sm={12} md={12}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Task Description{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  value={taskDescription}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim()) {
                      setTaskDescription(value);
                    } else if (value.length === 0) {
                      setTaskDescription(value);
                    }
                  }}
                />
                {errors.taskDescription && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskDescription}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Row 4 */}
          <Row className='mb-4'>
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Project Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={projectname}
                  options={projectOptions}
                  onChange={(option) => {
                    setProjectname(option);
                  }}
                />
                {errors.projectname && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.projectname}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Category Name
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={categoryname}
                  options={allCategoriesOptions}
                  isDisabled={!departmentName || !subDepartment}
                  onChange={(option) => {
                    setCategoryname(option);
                  }}
                />
                {/* {errors.categoryname && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.categoryname}
                  </p>
                )} */}
              </Form.Group>
            </Col>
          </Row>

          {/* Row 5 */}
          <Row className='mb-4'>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" className="w-100">
                <Form.Label className="mt-3 fw-bold">
                  Proposed Start date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="proposedStartDate"
                  value={proposedStartDate}
                  onKeyDown={(event) => event.preventDefault()}
                  onChange={(e) => {
                    setProposedStartDate(e.target.value);
                  }}
                />
                {errors.proposedStartDate && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.proposedStartDate}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Proposed End date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name='proposedEndDate'
                  value={proposedEndDate}
                  min={proposedStartDate}
                  disabled={proposedStartDate?.length === 0 ? true : false}
                  onChange={(e) => {
                    setProposedEndDate(e.target.value);
                  }}
                />
                {errors.proposedEndDate && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.proposedEndDate}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Estimate(Hours){" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Estimate Hr"
                  name="initialEstimateHr"
                  value={initialHr}
                  onChange={(e) => {
                    if (/^[0-9]*(\.[0-9]*)?$/.test(e.target.value) && e.target.value.length <= 4) {
                      setInitialHr(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setInitialHr(e.target.value);
                    }
                  }}
                />
                {errors.initialHr && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.initialHr}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Minutes{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Minutes"
                  name="initialminute"
                  value={initialminute}
                  onChange={(e) => {
                    if (/^[0-9]{0,2}$/.test(e.target.value) && e.target.value >= 0 && e.target.value <= 59) {
                      setInitialMinute(e.target.value);
                    } else if (e.target.value > 59) {
                      toast.error('Please enter a value between 0 and 59.')
                    } else if (e.target.value.length === 0) {
                      setInitialMinute(e.target.value);
                    }
                  }}
                />
                {errors.initialminute && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.initialminute}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

        </Modal.Body>
        {/* <Modal.Body size="lg">

          <Row className='mb-4'>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Project Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={projectname}
                  options={projectOptions}
                  onChange={(option) => {
                    setProjectname(option);
                  }}
                />
                {errors.projectname && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.projectname}
                  </p>
                )}
              </Form.Group>
            </Col>

            
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Department Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={departmentName}
                  options={localDeptOptions.selectedListInd != null ? localDeptOptions.data[localDeptOptions.selectedListInd]: []}
                  isDisabled={localDeptOptions.selectedOptionInd === null}
                  onChange={(option) => {
                    const optionIndex = localDeptOptions.data[localDeptOptions.selectedListInd].findIndex((itm) => itm.value === option.value && itm.label === option.label);
                    setLocalDeptOptions(prev => ({
                      ...prev,
                      selectedOptionInd: optionIndex,
                    }))
                    setDepartmentName(option);
                    setSubDepartment(null);
                    // setAssignto(null);
                  }}
                />
                {errors.departmentName && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.departmentName}
                  </p>
                )}
              </Form.Group>
            </Col>
              

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  SubDepartment Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={subDepartment}
                  options={subDeptOptions}
                  isDisabled={!departmentName || subDeptOptions.length === 0}
                  onChange={(option) => {
                    setSubDepartment(option);
                  }}
                />
                {errors.subDepartment && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.subDepartment}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Category Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={categoryname}
                  options={allCategoriesOptions}
                  onChange={(option) => {
                    setCategoryname(option);
                  }}
                />
                {errors.categoryname && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.categoryname}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={4}>
              <Form.Group controlId="formBasicId">
                <Form.Label className="mt-3 fw-bold">
                  Assign By
                </Form.Label>
                <Form.Control value={`${userData?.firstName} ${userData?.lastName}`} readOnly />
              </Form.Group>
            </Col>

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Assign To
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={assignto}
                  // isDisabled={!projectname || !departmentName || !subDepartment}
                  // options={useGetDeptwiseAssignTo}
                  options={assignToOptions}
                  onChange={(option) => {
                    // fint the index of selected option in assignToOptions\
                    const index = assignToOptions.findIndex((itm) => itm.value === option.value && itm.label === option.label);
                    setLocalDeptOptions(prev => ({
                      ...prev,
                      selectedListInd: index,
                      selectedOptionInd: 0,
                    }))
                    setDepartmentName(localDeptOptions.data[index][0]);
                    setAssignto(option);
                  }}
                />
                {errors.assignto && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.assignto}
                  </p>
                )}
              </Form.Group>
            </Col>

          </Row>


          <Row className='mb-4'>
            <Col sm={12} md={6}>
              <Form.Group controlId="formBasicId">
                <Form.Label className="mt-3 fw-bold">
                  Task Title
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Task Name"
                    value={taskName}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !value.match(/[#$&%!~=^_{}\[\]*|//\/?<>;`/\\]/) &&
                        value.trim()
                      ) {
                        setTaskName(value);
                      } else if (value.length === 0) {
                        setTaskName(value);
                      }

                    }}
                  />

                </InputGroup>
                {errors.taskName && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskName}
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Task Priority
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={taskpriority}
                  options={taskPriorityOptions}
                  onChange={(option) => {
                    setTaskpriority(option);
                  }}
                />
                {errors.taskpriority && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskpriority}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={12} md={12}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Task Description{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  value={taskDescription}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.trim()) {
                      setTaskDescription(value);
                    } else if (value.length === 0) {
                      setTaskDescription(value);
                    }

                  }}
                />
                {errors.taskDescription && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskDescription}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" className="w-100">
                <Form.Label className="mt-3 fw-bold">
                  Proposed Start date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  className=""
                  type="date"
                  name="proposedStartDate"
                  value={proposedStartDate}
                  // min={new Date().toISOString().split("T")[0]}
                  onKeyDown={(event) => event.preventDefault()}
                  onChange={(e) => {
                    setProposedStartDate(e.target.value);
                  }}
                />
                {errors.proposedStartDate && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.proposedStartDate}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Proposed End date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  className=""
                  type="date"
                  name='proposedEndDate'
                  value={proposedEndDate}
                  min={proposedStartDate}
                  disabled={
                    proposedStartDate?.length === 0 ? true : false
                  }
                  onChange={(e) => {
                    setProposedEndDate(e.target.value);
                  }}
                />
                {errors.proposedEndDate && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.proposedEndDate}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Estimate(Hours){" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Estimate Hr"
                  name="initialEstimateHr"
                  value={initialHr}
                  onChange={(e) => {
                    if (/^[0-9]*(\.[0-9]*)?$/.test(e.target.value) && e.target.value.length <= 4) {
                      setInitialHr(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setInitialHr(e.target.value);
                    }
                  }}
                />
                {errors.initialHr && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.initialHr}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Minutes{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Minutes"
                  className=""
                  name="initialminute"
                  value={initialminute}
                  onChange={(e) => {
                    if (/^[0-9]{0,2}$/.test(e.target.value) && e.target.value >= 0 && e.target.value <= 59) {
                      setInitialMinute(e.target.value);
                    } else if (e.target.value > 59) {
                      toast.error('Please enter a value between 0 and 59.')
                    }
                    else if (e.target.value.length === 0) {
                      setInitialMinute(e.target.value);
                    }
                  }}
                />
                {errors.initialminute && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.initialminute}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

        </Modal.Body> */}

        <Modal.Footer className="text-center mt-4">
          <Button className="primaryBtn " onClick={() => { handleSubmit() }}>
            <Icon.PersonAdd className='me-2' /> Create Task
          </Button>
        </Modal.Footer>
      </Modal>
    </>

  )
}

export default CreateTaskModel